import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FeatureFlag } from '@shared/models';

export const FeatureFlagActions = createActionGroup({
  source: 'Feature Flag Actions',
  events: {
    'Set Feature Flags': props<{ featureFlags: FeatureFlag }>(),
    'Reset Feature Flags': emptyProps,
  },
});
